/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_TitleInputs */



/**
* | output |
* | --- |
* | "Tools" |
*
* @param {Tools_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tools_title = /** @type {((inputs?: Tools_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Outils")
	if (locale === "es") return /** @type {LocalizedString} */ ("Herramientas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ferramentas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Strumenti")
	return /** @type {LocalizedString} */ ("Tools")
});